"use client";

import { c as _c } from "react/compiler-runtime";
import { useMS365Cloud } from "@ms-teams-poc/utils/hooks/m365cloud";
import { ADUserAvatar } from "@shared-components/ad-user-avatar";
import { Button } from "@shared-components/shadcn/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@shared-components/shadcn/dropdown-menu";
import { LogOut } from "lucide-react";
import { signOut, useSession } from "next-auth/react";
export const UserDropdown = () => {
  const $ = _c(19);
  const {
    data: session
  } = useSession();
  const ms365Cloud = useMS365Cloud();
  const disableLogout = ms365Cloud && "redirectUrl" in ms365Cloud;
  const t0 = session?.user?.image as string;
  const t1 = session?.user?.email as string;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" className="relative mx-2 h-8 w-8 rounded-full"><ADUserAvatar imagePath={t0} userPrincipalName={t1} size="small" /></Button></DropdownMenuTrigger>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DropdownMenuLabel className="pb-0 text-sm font-bold">{"Logged in"}</DropdownMenuLabel>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = session?.user?.name;
  let t5;
  if ($[4] !== t4) {
    t5 = <p className="text-sm font-medium leading-none">{t4}</p>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = session?.user?.email;
  let t7;
  if ($[6] !== t6) {
    t7 = <p className="text-xs leading-none text-muted-foreground">{t6}</p>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t7) {
    t8 = <DropdownMenuLabel className="font-normal"><div className="flex flex-col space-y-1">{t5}{t7}</div></DropdownMenuLabel>;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== disableLogout) {
    t9 = !disableLogout && <><DropdownMenuSeparator /><DropdownMenuItem onClick={_temp}><LogOut className="mr-2 h-4 w-4" /><span>{"Log out"}</span></DropdownMenuItem></>;
    $[11] = disableLogout;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <DropdownMenuContent className="w-56" align="end" forceMount={true}>{t3}{t8}{t9}</DropdownMenuContent>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t2) {
    t11 = <DropdownMenu modal={false}>{t2}{t10}</DropdownMenu>;
    $[16] = t10;
    $[17] = t2;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
function _temp() {
  return void signOut();
}